import { createContext } from 'react';
import type { NavMesh, NavMeshQuery } from '@recast-navigation/core';
import { SoloNavMeshGeneratorIntermediates } from '@recast-navigation/generators';

export type NavMeshGeneratorContextValue = {
  navMesh: NavMesh | null;
  query: NavMeshQuery | null;
  intermediates: SoloNavMeshGeneratorIntermediates | null;
  success: boolean;
};
export const NavMeshGeneratorContext = createContext<NavMeshGeneratorContextValue | null>(null);

export type NavMeshGeneratorResult = {
  navMesh: NavMesh;
  intermediates: SoloNavMeshGeneratorIntermediates;
};

export type NavMeshInternalContextValue = {
  cache: Map<string, NavMeshGeneratorResult>;
  worker: Worker;
  setContext: React.Dispatch<React.SetStateAction<NavMeshGeneratorContextValue | null>>;
};

export const NavMeshGeneratorInternalContext = createContext<NavMeshInternalContextValue | null>(
  null,
);
